import { renderSlot as _renderSlot, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "inline text-hex-6664D6 relative font-500 group text-22px <lg:text-14px pb-5px" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("button", _hoisted_1, [
    _renderSlot(_ctx.$slots, "default"),
    _cache[0] || (_cache[0] = _createElementVNode("div", { class: "transition transform-gpu sm:group-hover:-translate-y-5px border border-t-hex-6664D6 w-full absolute -bottom-13px <xl:-bottom-1/4 <sm:-bottom-0px" }, null, -1))
  ]))
}